import { Injectable } from '@angular/core';

import { HttpClient, HttpParams } from '@angular/common/http';

import { BaseService } from 'src/app/core/services/base.service';

import { Observable, Subject } from 'rxjs';

import { map } from 'rxjs/operators';

import { CacheDuration, DateFormat } from 'src/app/core/constants/app.constant';

import { saveMasterConfig } from './settings';

import { IResponse } from 'src/app/shared/models/app';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { SessionStorageService } from 'ngx-webstorage';




@Injectable({

  providedIn: 'root'

})

export class SettingsService extends BaseService {

  constructor(protected http: HttpClient,private cache:CacheResolverService,private sessionStorage: SessionStorageService) {
    super(http);
  }

  // getMasterConfiguration(type:number): Observable<any> {
  //   const request = {};
  //   const url = super.serviceUrl(this.apiConfig.config+'/api/configuration/search?&type=',type);
  //   return this.http.get(url);
  // }
  getusersConfig(): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/users?onlyActiveUsers=N');
    return super.fetch(url);
  }
  geteachuserConfig(id): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/user/', id);
    return super.fetch(url);
  }
  getCountOfActiveUsers(){
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/count');
    return super.fetch(url);
  }
  getUserDetailsByEmail(email):Observable<any>{
    const url = this.apiConfig.util+'/api/userManagement/user';
    return this.http.get(url,{params:new HttpParams().set('email', encodeURIComponent(email)),observe: 'response'});
  }
  getUserPermissions(): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/permissions');
    return super.fetch(url);
  }
  getUserTemplates(): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/templates');
    return super.fetch(url);
  }
  deleteUserManagement(id: any) {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/delete/', id);
    return this.http.delete(url);
  }
  saveUserConfig(data: any, id: any) {
    if(id){
      const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/update/', id);
      return super.put(url, data);
    }
    else{
      const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/save');
      return super.post(url, data);
    }
  }

  getMasterConfiguration(type: number): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config+'/api/configuration/search?&type=', type);
    return this.http.get(url);
  }

  saveMaster(resp: saveMasterConfig[], type: any) {
    const url = super.serviceUrl(this.apiConfig.config+'/api/configuration/configtype/', type, '/configvalue?');
    return super.put(url, resp);
  }

  postDataService(data, getTableData) {
    const url = this.apiConfig.config+"/api/configuration/configtype/" + getTableData + "/configvalue";
    return super.post(url, data);
  }

  getProductDetails() {
    let url = super.serviceUrl(this.apiConfig.inventory+"/api/product");
    return super.fetch(url);
  }

  getBarcodeDetails() {
    let url = super.serviceUrl(this.apiConfig.util+"/api/barcodeconfiguration/41?");
    return this.http.get(url);
  }

  postBarcodeData(data) {
    return this.http.post(this.apiConfig.util+"/api/barcodeconfiguration?cacheBuster=1641536932854", data);
  }

  //Sharing
  getDepartments() {
    const url2 = this.apiConfig.patient+"/api/sharing";
    return this.http.get(url2);
  }

  updateDepartments(data) {
    const url = this.apiConfig.patient+"/api/sharing/update";
    return this.http.put(url, data);
  }
  generateToken() {
    const url3 = this.apiConfig.patient+"/api/sharing/generateToken";
    return this.http.get(url3);
  }
  validateToken(data) {
    const url4 = this.apiConfig.patient+"/api/sharing/validateToken?token=" + data + "";
    return this.http.get(url4);
  }

  deleteSharing(data) {
    const url = this.apiConfig.patient+"/api/sharing/" + data + "";
    return this.http.delete(url);
  }

  acceptToken(data) {
    const url = this.apiConfig.patient+"/api/sharing";
    return this.http.post(url, { token: data });
  }

  getCompDetails() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config+'/api/component');
    return this.http.get(url);
  }
  getOrderingPhysicians(): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config+'/config/orderingphysicians');
    return super.post(url, {}).pipe(
      map((res: any) => {
        res.data.forEach(physician => {
          physician.fullName = physician.lastName + " " + physician.firstName;
          physician.id = physician.orderingPhysicianNum;
        });
        return res
      })
    )
  }
  getPurchaseOrders(): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config+'/config/purchaseorders');
    return super.post(url, {});
  }

  findOrderOrProcMapped(data): Observable<any> {
    const request = {};
    const id = data;
    const url = super.serviceUrl(this.apiConfig.config+"/config/components/findOrderOrProcMapped/" + id);
    return super.post(url, {});
  }
  deleteComponent(data): Observable<any> {
    const request = {};
    const id = data;
    const url = super.serviceUrl(this.apiConfig.config+'/config/components/' + id);
    return super.delete(url, {});
  }
  saveCompDetails(data) {
    const url = this.apiConfig.config+"/config/components/save";
    return super.post(url, data);
  }

  getProducts() {
    const url = super.serviceUrl(this.apiConfig.inventory+'/api/product/search?type=0');
    return super.fetch(url);
  }

  getProcedureDetails() {
    let url = super.serviceUrl(this.apiConfig.config+"/config/procedures?componentsupplynames=true&fields=name");
    return super.fetch(url).pipe(map((response: IResponse) => {
      return this.setProcedures(response.data);
    }));
  }

  setProcedures(procedures) {
    procedures.forEach(procedure => {
      var label = [];
      procedure.procedureComponent.forEach(function (pc) {
        label.push(pc.component.name);
      });
      procedure.procedureSupply.forEach(function (ps) {
        label.push(ps.supply.name);
      });
      procedure.label = label.join('|');
    });
    return procedures;
  }

  getProcedureData(id: number) {
    let url = super.serviceUrl(this.apiConfig.config+"/config/procedures/", id);
    return this.http.get(url);
  }

  getDosingTable() {
    let url = super.serviceUrl(this.apiConfig.config+"/config/doseFactors");
    return this.http.get(url);
  }

  getGroupDosing() {
    let url = super.serviceUrl(this.apiConfig.config+"/config/types/search?group=dosing");
    return this.http.get(url);
  }

  deleteProcedure(id: any) {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.patient+'/api/patientvisit/procedure');
    return this.http.delete(url, { params: { patientVisitNum: id } });
  }

  cancelProcedure(id: any) {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.patient+'/api/patientvisit/', id);
    return this.http.delete(url);
  }

  getVarCalculations() {
    const url = super.serviceUrl(this.apiConfig.config+'/api/qccalculationvariablereferences');
    return super.fetch(url);
  }

  getQCDetails() {
    const url = super.serviceUrl(this.apiConfig.config+'/api/config/qcprodformdetails');
    return super.fetch(url);
  }

  saveQc(data) {
    const url = this.apiConfig.config+"/api/config/qcprodformdetails/save";
    return super.post(url, data);
  }

  getPreferenceData() {


    return super.fetch(this.apiConfig.config+'/api/preference',
    {params:{fields:"note,name,canOverride,options,preferenceValueType,group,minValue,maxValue,canDisplay"}}).pipe(map((response: IResponse) => {
      this.cache.set(
        CacheConstant.LocalStorage.Preferences,
        response.data,
        CacheDuration.OneDay
      );
      return response;
    }));
  }

  savePrefernces(list){
    return super.put(this.apiConfig.config+'/api/preference',list);
}
// -----------------------------------------------------
helpDocuments(){
  const url=this.apiConfig.config+'/api/media/help'
  return super.fetch(url, {});
}
deleteHelp(id){
      const url = super.serviceUrl(this.apiConfig.config+'/api/media/help/'+id);
      return super.delete(url);

    }
moveFile(data){
  const url = this.apiConfig.config+'/api/media/help/movedocument?'
  return this.http.post(url,data);
}

 addFolder(data, id){
     const url=this.apiConfig.config+'/api/media/help/folder'
     if(id==0 || id==undefined) {
      return super.post(url,data)
    } else {
      return super.post(url,data, { params: {"rootPath": id} })
    }
    }
editFolder(data,id){
  const url=super.serviceUrl(this.apiConfig.config+'/api/media/help/'+id)
return this.http.put(url,data)
}
addFile(data){
  const url=this.apiConfig.config+'/api/media/help'
  return this.http.post(url,data)
}
toTheFolder(id){
  const url=super.serviceUrl(this.apiConfig.config+'/api/media/help');
  if(id==0 || id==undefined) {
    return super.fetch(url)
  } else {
    return super.fetch(url, { params: {"rootPath": id} })
  }

}
searchDoc(searchText){
  const url=super.serviceUrl(this.apiConfig.config+'/api/media/help/search?&searchStr='+searchText)
  return super.fetch(url, {});
}
saveTrainingForFolder(data,id){

  const url=super.serviceUrl(this.apiConfig.config+'/api/media/help?rootPath='+id)
return this.http.post(url,data)
}
saveTraining(data, id){
  const url=super.serviceUrl(this.apiConfig.config+'/api/media/help')
  if(id==0 || id==undefined) {
    return super.post(url,data)
  } else {
    return super.post(url,data, { params: {"rootPath": id} })
  }
}
saveTrainingForSurvey(data){
  const url=super.serviceUrl(this.apiConfig.config+'/api/media/help')
return this.http.post(url,data)
}
reuploadTraining(data){
  const url=super.serviceUrl(this.apiConfig.config+'/api/media/help/file')
return this.http.put(url,data)
}

getBinaryReportforSurvey(urll){
  const url= super.serviceUrl(this.apiConfig.config+'/'+urll)
return this.http.get(url,{ responseType: 'arraybuffer' })
}

getBinaryReport(faxUrl){
  const url = super.serviceUrl(this.apiConfig.config+'/' + faxUrl);
  return super.fetch(url,
      {
          headers: {
              accept:
                  'application/json'
          },
          observe: 'response',
          responseType: 'blob' as 'json'
      }
  ).pipe(
      map((response: IResponse) => {
          if (!response.hasError && response.data) {
              return response.data;
          } else {
              return null;
          }
      })
  );

}

deleteTraining(id){
  const url =this.apiConfig.config+'/api/media/help/'+id;
  return this.http.delete(url);
}

getVendors(){
  const url =this.apiConfig.util+'/api/vendors';
  return super.fetch(url);
}

getBarcodeDetailsforVendor(vendorId){
  const url =this.apiConfig.util+'/api/barcodeConfiguration/search';
  return super.fetch(url,{params:{vendorId:vendorId}});
}

saveBarcodeConfig(request,vendor){
  return super.post(this.apiConfig.util+'/api/barcodeConfigtype/'+ vendor.id +'/configvalue',request);
}
updateBarcodeConfig(request,vendor){
  return super.put(this.apiConfig.util+'/api/barcodeConfigtype/'+ vendor.id +'/configvalue',request);
}

addNewDoseFactor(request){
  return super.post(this.apiConfig.config+ '/config/dosefactors',request);
}

deleteDoseFactor(request){
  const url = super.serviceUrl(this.apiConfig.config+'/config/dosefactor');
  return this.http.delete(url, { params: { id: request.id,doseFactor:request.doseFactor,weight:request.weight } });
}

updateDoseFactors(request){
  return super.post(this.apiConfig.config+ '/config/dosefactors',request);
}

getTemplate(id) {
  return super.fetch(this.apiConfig.config + '/config/theranostics-templates?prodformid=' + id)

}

getActiveUsersPermissionsAuditReport(reportData, reportId) {
  const url = this.apiConfig.report + '/api/report/request/' + reportId;
  return super.post(url, reportData, reportId);
}

getActiveUsers(): Observable<any> {
  const request = {};
 const  customerShipToNum = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo)
  const url = super.serviceUrl(this.apiConfig.util+'/api/user/allUsers?custShipToNum='+customerShipToNum);
  return super.post(url,{});
}

}
